import { render, staticRenderFns } from "./UserRecruitment.vue?vue&type=template&id=dfa1cf02&"
import script from "./UserRecruitment.vue?vue&type=script&lang=js&"
export * from "./UserRecruitment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports